import React from "react";
import { Autocomplete, TextField } from "@mui/material";

export interface OptionItem {
  id: number;
  nome: string;
  ativo?: boolean | number | string | null;
  created_at?: string;
  updated_at?: string;
}

interface SearchSelectProps {
  label?: string;
  options: OptionItem[];
  value: number | null;
  onChange: (id: number | null) => void;
  placeholder?: string;
  disabled?: boolean;
  disableInactiveOptions?: boolean;
  error?: boolean;
  helperText?: React.ReactNode;
  paperClassname?: string | undefined;
  popperClassname?: string | undefined;
  labelClassname?: string | undefined;
  inputClassname?: string | undefined;
  containerClassname?: string | undefined;
}

const SearchSelect: React.FC<SearchSelectProps> = ({
  label,
  options,
  value,
  onChange,
  placeholder = "Selecione...",
  disabled = false,
  disableInactiveOptions = false,
  error = false,
  helperText,
  paperClassname,
  popperClassname,
  labelClassname,
  inputClassname,
  containerClassname,
}) => {
  
  const selectedOption = options.find(opt => opt.id === value) || null;

  return (
    <div className={`w-full ${containerClassname || ""}`}>
      <Autocomplete
        slotProps={{
          paper: {
            className: paperClassname,
          },
          popper: {
            className: popperClassname,
          },
        }}
        options={options}
        value={selectedOption}
        disabled={disabled}
        getOptionDisabled={(option) => disableInactiveOptions && (option.ativo === false || option.ativo === 0 || option.ativo === "0")}
        getOptionLabel={(option) => option.nome}
        getOptionKey={(option) => option.id}
        onChange={(_, newValue) => {
          onChange(newValue ? newValue.id : null);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={placeholder}
            size="small"
            variant="standard"
            className="bg-white"
            error={error}
            helperText={helperText}
            InputProps={{
              ...params.InputProps,
              className: inputClassname,
              disableUnderline: true,
            }}
            InputLabelProps={{
              className: labelClassname,
            }}
          />
        )}
      />
    </div>
  );
};

export default SearchSelect;
